import { planTypes } from '@/common/constants';
import { defaultMapper } from '@/common/service/default-mapper';

const basicPlusCategory = {
  zobasicp: { typeNameKey: 'billing.zone_basic_plus.title', planNameKey: 'billing.zone_basic_plus.title' },
  zobasicpm: { typeNameKey: 'billing.zone_basic_plus.title', planNameKey: 'billing.zone_basic_plus.title' },
};

export default (planMapJSON = {}) => {
  return Object.keys(basicPlusCategory).reduce((pre, key) => {
    return [
      ...pre,
      ...defaultMapper(planMapJSON[key], planTypes.ZONE_BASIC_PLUS).map(item => ({
        ...item,
        category: item.category.toLocaleLowerCase(),
        ...basicPlusCategory[key],
        supportCoupon: false,
      })),
    ];
  }, []);
}
